(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('VirtualFairExportDataController', VirtualFairExportDataController)

    VirtualFairExportDataController.$inject = ['$uibModal', 'VirtualFairService', 'AclService'];


    function VirtualFairExportDataController($uibModal, VirtualFairService, AclService) {
        var vm = this;

        // vm.exhibitors            = '';
        // vm.queryFlag             = false;
        vm.expos             = '';
        vm.expoSelected      = '';
        vm.listVirtualFairs  = listVirtualFairs;
        vm.dataToExport      = [
            {id: 'cities', name: 'Cities'},
            {id: 'regions', name: 'Regions'},
            {id: 'countries', name: 'Countries'},
            {id: 'scholarities', name: 'Scholarities'},
            {id: 'profile-types', name: 'Profile Types'},
            {id: 'areas-of-interest', name: 'Areas of Interest'},
            {id: 'matches', name: 'Matches'},
            {id: 'students', name: 'Students'},
            {id: 'exhibitors', name: 'Exhibitors'},
            {id: 'university-connect', name: 'University Connect Institutions'}
        ];
        // vm.getByFilter           = getByFilter;
        // vm.openUploadModal       = openUploadModal;

        /* PAGINATION */
        // vm.pageChanged  = pageChanged;
        // vm.setPage      = setPage;
        // vm.totalItems   = 0;
        // vm.currentPage  = 0;
        // vm.itemsPerPage = 0;
        // vm.page         = 1;


        activate();


        // function setPage(page) {
        //     vm.currentPage = page;
        // };


        // function pageChanged(page) {
        //     vm.page = vm.currentPage;
        //     vm.getByFilter();
        // };


        function activate() {
            vm.listVirtualFairs();
        }

        function listVirtualFairs() {
            var today = new Date(),
                today = today.getUTCFullYear() + '-' + (today.getUTCMonth()+1) + '-' + today.getUTCDate();

            vm.query = {};
            vm.query['search'] = today;
            vm.query['searchFields'] = 'expo_date:>=';
            vm.query['orderBy'] = 'expo_date';

            VirtualFairService.all(vm.query).then(function(response){
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        // function getByFilter() {
        //     vm.query = {};
        //     vm.query['search'] = vm.expoSelected.id;
        //     vm.query['searchFields'] = 'virtual_fair_id';
        //     vm.query['orderBy']      = 'name';
        //     vm.query['page'] = vm.page;

        //     VirtualFairService.getExhibitors(vm.query).then(function(response) {
        //         vm.exhibitors = response.data.data;
        //         vm.totalItems = response.data.total;
        //         vm.itemsPerPage = response.data.per_page;
        //         vm.queryFlag = true;
        //         vm.setPage(response.data.current_page);

        //     }).catch(function(err) {
        //     });
        // }

    }

})();